// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"1c7aeb14","543":"50354fff","658":"8198be08","956":"d814ef97"}[chunkId] + ".chunk.css";
};